import dashboard from "../../dashboard/reducers";
import events from "../../events/reducers";
import activeModal from "../../modals/reducers";
import createResourceReducer from "../../resources/reducers";
import inFlight from "../../resources/reducers/inFlight";
import theme from "../../themes/reducers";
import site from "./site";
import { combineReducers } from "redux";

const resourceNames = [
  "pages",
  "sections",
  "events",
  "guests",
  "rsvps",
  "sites",
  "registries",
  "attendants",
  "accommodations",
  "image-uploads",
  "photos",
  "tasks",
  "invites",
  "comments",
  "videos",
];

export default combineReducers({
  activeModal,
  dashboard,
  events,
  inFlight,
  resources: createResourceReducer(resourceNames),
  site,
  theme,
});
